import React, { useState } from "react";

const FaqItem = ({ id, q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`ic-faq-item ${open ? "open" : ""}`}>
      <h3 className="ic-faq-q">
        <button
          type="button"
          id={`${id}-btn`}
          aria-expanded={open}
          aria-controls={`${id}-panel`}
          onClick={() => setOpen((v) => !v)}
        >
          <span>{q}</span>
          <span className="ic-faq-icon" aria-hidden="true">
            {open ? "−" : "+"}
          </span>
        </button>
      </h3>
      <div id={`${id}-panel`} role="region" aria-labelledby={`${id}-btn`} hidden={!open} className="ic-faq-a">
        <p>{a}</p>
      </div>
    </div>
  );
};

const Faq = ({ items }) => (
  <div className="ic-faq">
    {items.map((item, i) => (
      <FaqItem key={item.q} id={`ic-faq-${i}`} q={item.q} a={item.a} />
    ))}
  </div>
);

export default Faq;
